export default __webpack_public_path__ + "static/media/activeCircle.cd46a258.svg";